import { Tabs } from '@mantine/core';
// components
import { CopyButton } from '@newo/ui-kit';
import { TPersona } from '@newo/api/gateway';
import Drawer from '@/components/Drawer';
import Details from '@/pages/Personas/components/Details';
import Actors from '@/pages/Personas/components/Actors';
// utils

interface PersonaDrawerProps {
    persona?: TPersona;
    onClose: () => void;
    refetch: () => void;
}

const PersonaDrawer = ({ persona, onClose, refetch }: PersonaDrawerProps) => {
    const handleDetailsSubmit = () => {
        onClose();
        refetch();
    };

    return (
        <Drawer
            name="personas-persona-details"
            opened={!!persona}
            position="right"
            size="md"
            title={
                <div>
                    {persona?.name ?? ''}
                    <div className="flex items-center gap-2 text-xs text-gray-6 font-normal mt-1">
                        Id: {persona?.id} <CopyButton value={persona?.id} />
                    </div>
                </div>
            }
            onClose={onClose}
        >
            <Tabs defaultValue="details">
                <Tabs.List>
                    <Tabs.Tab value="details">Persona Details</Tabs.Tab>
                    <Tabs.Tab value="actors">Actors</Tabs.Tab>
                </Tabs.List>
                <Tabs.Panel className="h-full py-3" value="details">
                    {persona ? (
                        <Details
                            persona={persona}
                            onClose={onClose}
                            onSubmit={handleDetailsSubmit}
                        />
                    ) : undefined}
                </Tabs.Panel>
                <Tabs.Panel className="h-full py-3" value="actors">
                    <Actors persona={persona} />
                </Tabs.Panel>
            </Tabs>
        </Drawer>
    );
};

export default PersonaDrawer;
